import { render, staticRenderFns } from "./loctypedetail.vue?vue&type=template&id=0a7b14d2&scoped=true"
import script from "./loctypedetail.vue?vue&type=script&lang=js"
export * from "./loctypedetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b14d2",
  null
  
)

export default component.exports